export default "__VITE_ASSET__BzkMewl___"